import { Share2 } from "lucide-react";
import { useState } from "react";

import { Button } from "@/design-system/Button";

import { cardImage, shareImage, type Card } from "./shareCard";

const SAID: Readonly<Record<string, string>> = {
  saved: "Картинка сохранена и скопирована — вставьте её в чат.",
  failed: "Не получилось. Попробуйте ещё раз.",
};

/** One button: the card, with the amount hidden unless the client shows it. */
export function ShareButton({ card, name, label = "Поделиться" }: {
  readonly card: Card;
  /** The saved file's name, without extension. */
  readonly name: string;
  readonly label?: string;
}): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const [hide, setHide] = useState(true);
  const [busy, setBusy] = useState(false);
  const [said, setSaid] = useState<string | null>(null);
  if (!open) {
    return (
      <Button type="button" variant="ghost" size="sm" onClick={() => { setOpen(true); setSaid(null); }} aria-label={label} title={label}>
        <Share2 aria-hidden="true" className="size-4" />
        <span className="max-sm:sr-only">{label}</span>
      </Button>
    );
  }
  return (
    <span className="inline-flex flex-wrap items-center gap-2" data-testid="share-card">
      <label className="inline-flex cursor-pointer items-center gap-1 text-helper-sm text-text-secondary">
        <input type="checkbox" className="cursor-pointer" checked={!hide} onChange={(event) => { setHide(!event.target.checked); }} />
        показать сумму
      </label>
      <Button
        type="button"
        variant="primary"
        size="sm"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setSaid(null);
          void cardImage(card, hide)
            .then((image) => shareImage(image, `${name}.png`))
            .then((outcome) => { setSaid(SAID[outcome] ?? null); if (outcome !== "saved") setOpen(false); })
            .catch(() => { setSaid(SAID.failed ?? null); })
            .finally(() => { setBusy(false); });
        }}
      >
        {busy ? "Готовлю…" : "Отправить картинку"}
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={() => { setOpen(false); }}>Отмена</Button>
      {said !== null && <span role="status" className="text-helper-sm text-text-secondary">{said}</span>}
    </span>
  );
}
